import React, { memo, useEffect, useRef, useState } from "react";
import { func, object, string } from "prop-types";
import { connect } from "react-redux";
import { trim } from "lodash";

import FilterInput from "../../atoms/FilterInput";

import { staticTexts } from "../../utils/Translate";

import "./section-search-input.m.css";

const SectionSearchInput = ({ query = {}, lang, className = "", domainSlug = null, navigateToPage = () => {} }) => {
  const [clear, setClear] = useState(Boolean(query["section-id"]));
  const [domainSections, setDomainSections] = useState([]);
  const [sectionName, setSectionName] = useState("");
  const ref = useRef(null);
  const [filteredSections, setFilteredSections] = useState([]);
  const [arrowSections, setArrowSections] = useState([]);

  useEffect(() => {
    const fileUrl = `/sections-data/${domainSlug || (lang === "bn" ? "bangla" : "english")}.json`;
    fetch(fileUrl)
      .then((res) => res.json())
      .then((sections) => {
        setDomainSections(sections);
        setArrowSections(!domainSlug ? sections.filter((item) => item.arrow) : sections);
        if (query["section-id"]) {
          const sectionId = query["section-id"].split(",")[0];
          const selectedSection = sections.find(({ id }) => Number(sectionId) === id);
          setSectionName(selectedSection?.["display-name"] || selectedSection?.name);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);

  const sectionsFilter = (value) => {
    setSectionName(value);
    value = trim(value);
    setClear(Boolean(value));

    if (String(value).length) {
      const regex = new RegExp(value, "gim");
      const filtered = domainSections.filter(({ "display-name": name = "" }) => name.match(regex)).slice(0, 5);
      setFilteredSections(filtered);
    } else {
      setFilteredSections(arrowSections);
    }
  };

  const onChange = (e) => {
    sectionsFilter(e.target.value);
  };

  const onClear = () => {
    setClear(false);
    setSectionName("");
    setFilteredSections([]);
    if (query["section-id"]) {
      delete query["section-id"];
      const queryString = new URLSearchParams(query).toString();
      navigateToPage(`/search?${queryString}`);
    }
  };

  const sectionClick = (section) => {
    setSectionName(section["display-name"]);
    setFilteredSections([]);

    const ids = domainSections
      .filter(({ "parent-id": parentId }) => section.id === parentId)
      .map(({ id }) => id)
      .join(",");

    query["section-id"] = ids ? `${section.id},${ids}` : section.id;
    const queryString = new URLSearchParams(query).toString();
    navigateToPage(`/search?${queryString}`);
  };

  useEffect(() => {
    const outsideClick = (event) => {
      if (ref.current && !ref.current.contains(event.target)) {
        setFilteredSections([]);
      }
    };
    document.addEventListener("click", outsideClick);

    return () => document.removeEventListener("click", outsideClick);
  }, []);

  const onInputClick = (e) => {
    const { value } = e.target;
    if (filteredSections.length > 0) {
      setFilteredSections([]);
    } else if (filteredSections.length === 0 && !value) {
      setFilteredSections(arrowSections);
    } else if (String(value).length) {
      const regex = new RegExp(value, "gim");
      const filtered = domainSections.filter(({ "display-name": name = "" }) => name.match(regex)).slice(0, 5);
      setFilteredSections(filtered);
    }
  };

  const getParent = (section) => {
    const parentSection = domainSections.find((item) => item.id === section["parent-id"]);
    if (parentSection) {
      return parentSection["display-name"] || parentSection.name;
    }

    return "";
  };

  return (
    <div className={className} styleName="base" ref={ref}>
      <FilterInput
        type="text"
        onChange={onChange}
        isOpen={filteredSections.length > 0}
        isClear={clear}
        placeHolder={staticTexts(lang).sekasana}
        lang={lang}
        clearIcon={true}
        value={sectionName}
        id="section-input"
        onInputClick={onInputClick}
        onClear={onClear}
      />
      {filteredSections.length > 0 && (
        <div styleName="dropdown">
          <div styleName="sections">
            {filteredSections.map((section, index) => (
              <div styleName="section-name" key={index} onClick={() => sectionClick(section)}>
                {section["display-name"] || section.name}
                <span styleName="parent-name">{getParent(section)}</span>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

SectionSearchInput.propTypes = {
  domainSlug: string,
  lang: string,
  query: object,
  className: string,
  navigateToPage: func,
};

const mapStateToProps = (state) => ({
  domainSlug: state.qt.config.domainSlug,
});

const mapDispatchToProps = (dispatch) => ({
  navigateToPage: (url) => global.app.navigateToPage(dispatch, url),
});

export default memo(connect(mapStateToProps, mapDispatchToProps)(SectionSearchInput));
